import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "matching-card__header" }
const _hoisted_2 = { class: "matching-card__body" }
const _hoisted_3 = { class: "matching-card__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
      'matching-card--selected': _ctx.isSelected,
      'matching-card--faded': _ctx.isFaded && !_ctx.isDisabled,
      'matching-card--disabled': _ctx.isDisabled,
    }, "matching-card"])
  }, [
    _renderSlot(_ctx.$slots, "action", {}, undefined, true),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "header", {}, undefined, true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "body", {}, undefined, true),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
      ])
    ])
  ], 2))
}